export default {"src":"/_next/static/media/delhi-daredevils.b4f9c4d3.svg","height":130,"width":155,"blurWidth":0,"blurHeight":0};